module.exports = __webpack_public_path__ + "img/Rose1.609a02c7.jpg";